import getScenarioStore from '../store/getScenarioStore';
import { SearchScenarioId } from 'owa-search-next-common';

export default function isSearchSessionActive(scenarioId: SearchScenarioId): boolean {
    // User is in active search session if searchSessionGuid is set.
    return !!getScenarioStore(scenarioId).searchSessionGuid;
}
